// @ts-nocheck
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useGetUserInfoQuery } from 'store/services/segmentsApi';
import { userDetailsState } from 'store/userDetailsSlice';

export const SegmentAnalytics = () => {
  const location = useLocation();
  const { loggedIn } = useSelector(userDetailsState);

  // Do not fetch if authenticating from Shopify, reason is if the user is logged in, however the user token is expired, it will redirect the user to the login page and cancel the shopify authentication, throwing errors on Sentry
  const isShopifyAuthAddress = location.pathname.includes(
    '/integrations/shopify'
  );

  const { data: userInfo } = useGetUserInfoQuery(undefined, {
    skip: !!!loggedIn || isShopifyAuthAddress,
  });

  useEffect(() => {
    if (process.env.NODE_ENV === 'production') {
      const script = document.createElement('script');
      script.src = '/scripts/segmentAnalytics.js';
      script.async = true;
      document.body.appendChild(script);
      script.onload = () => window.analytics?.page();

      return () => {
        document.body.removeChild(script);
      };
    }
  }, []);

  useEffect(() => {
    // Only calls the analytics update if there is search terms, that's to avoid duplicate reporting when the app is first redirected to /dashboard, then added the URL queries
    if (process.env.NODE_ENV === 'production' && location.search) {
      window.analytics?.page();
    }
  }, [location.pathname, location.search]);

  useEffect(() => {
    if (userInfo?.id) {
      window.analytics?.identify(userInfo?.id);
    }
  }, [userInfo?.id]);

  return null;
};
